<template>
  <input
    id=""
    v-model="values"
    :type="mode"
    class="form-control"
    style="width:100%"
  />
</template>
<script>
export default {
  props: ['id', 'inputMode', 'inputValue', 'target'],
  data() {
    return {
      mode: this.inputMode,
      values: null,
    }
  },
  watch: {
    values: function(value) {
      this.$emit('inputEvent', value, this.id, this.target)
    },
    inputValue: function(value) {
      this.values = value
    },
  },
  mounted() {
    if (this.inputMode === 'number') {
      this.values = this.inputValue || 0
    } else {
      this.values = this.inputValue
    }
  },
}
</script>
